<div class="content campaign-home">
  <nav mat-tab-nav-bar
       [tabPanel]="tabPanel">
    <a mat-tab-link
       (click)="tabIndex = 0"
       [active]="tabIndex == 0">
      <i class="fal fa-sticky-note spacerRight"></i>
      <span class="ab-tab-link-text">Notes</span>
    </a>
    <a mat-tab-link
       (click)="tabIndex = 1"
       [active]="tabIndex == 1">
      <i class="fal fa-gauge-high spacerRight"></i>
      <span class="ab-tab-link-text">Dashboard</span>
    </a>
  </nav>
  <mat-tab-nav-panel #tabPanel>

    <div class="notes-tab {{tabIndex==0 ? 'selected' : ''}}">
      <div class="campaign-notes">
        <div class="add-buttons">

          <button *appIfMinRole="'organizer'"
                  class="btn"
                  (click)="onAddNoteClick()">
            <i class="fal fa-sticky-note spacerRight"></i> Add Note
          </button>

          <!-- TODO: Implement adding files here -->
          <!-- <button class="btn"
                  (click)="onAddFileClick()">
            <i class="fal fa-paperclip spacerRight"></i> Add File
          </button> -->

          <mat-form-field class="search ongray">
            <mat-icon matIconPrefix
                      fontSet="far fa-fw"
                      fontIcon="fa-magnifying-glass"
                      class="color--gray--007"></mat-icon>
            <input matInput
                   type="search"
                   placeholder="Search Campaign Notes"
                   [formControl]="quickSearchInput">
          </mat-form-field>
        </div>

        <app-view-notes [notes]="filteredNotes$ | async"
                        [targetType]="'Campaign'"
                        [targetId]="campaignId">
        </app-view-notes>


      </div>
    </div>
    <div class="dashboard-tab {{tabIndex==1 ? 'selected' : ''}}">
      <div>
        <!-- Wall Chart Section -->
        <div class="table">
          <div class="tr tr--noGutter tile__heading pt-0 pb-0 pr-0">
            <i class="fal fa-th-list spacerRight"></i>
            Wall Chart
          </div>
          <div class="tr tr--noGutter">
            <a routerLink="/entity/list"
               [queryParams]="allEntityTypesQueryParams"
               class="link">
              {{totalEntitiesCount}}
            </a>
          </div>
          <div class="tr tr--noGutter">
            <i class="item-icon fal fa-flag spacerRight"></i>
            <a routerLink="/entity/list"
               [queryParams]="flaggedEntitiesQueryParams"
               class="link">
              {{flaggedCount}}
            </a>
          </div>
          <div class="tr tr--noGutter">
            <i class="item-icon fal fa-flag spacerRight"></i>
            <a routerLink="/entity/list"
               [queryParams]="flaggedForCurrentUserQueryParams"
               class="link">
              {{flaggedForCurrentUserCount}}
            </a>
          </div>
          <div class="tr tr--noGutter">
            <i class="item-icon fal fa-flag spacerRight"></i>
            <a routerLink="/entity/list"
               [queryParams]="flaggedByYouQueryParams"
               class="link">
              {{flaggedByUserCount}}
            </a>
          </div>
        </div>

        <!-- Tasks Section -->
        <div class="table">
          <div class="tr tr--noGutter tile__heading pt-0 pb-0 pr-0">
            <i class="fal fa-clipboard-check spacerRight"></i>
            Tasks
          </div>
          <div class="tr tr--noGutter">
            <a routerLink="/action/list/you"
               [queryParams]="{campaignId: campaignId}"
               class="link">
              {{assignedTasksText}}
              <div class="meta">{{nextTaskDueText}}</div>
            </a>
          </div>
          <div class="tr tr--noGutter">
            <a routerLink="/action/list/manage"
               [queryParams]="{campaignId: campaignId}"
               class="link">
              {{totalTasksText}}
            </a>
          </div>
        </div>

        <!-- Activity Section -->
        <div class="table activity-list-group">
          <div class="link link--noline tr tr--noGutter tile__heading pt-0 pb-0 pr-0"
               routerLink="/activity/list"
               [queryParams]="{campaignId: campaignId}">
            <i class="fal fa-history spacerRight"></i>
            Activity
          </div>
          <div class="tr tr--noGutter"
               *ngIf="!activities">{{loadingMsg}}</div>
          <ng-container *ngFor="let activity of activities">
            <div class="tr tr--noGutter">
              <div class="activity-item">
                <app-activity-event-item [item]="activity"
                                         data-id="{{activity.id}}"
                                         class="ab-list-item w-100">
                </app-activity-event-item>
                <div class="meta activity-date">{{activity.createdAt | activityDateTime}}</div>
              </div>
            </div>
          </ng-container>
          <div class="tr tr--noGutter">
            <a routerLink="/activity/list"
               [queryParams]="{campaignId: campaignId}"
               class="link">
              See all activity
            </a>
          </div>
        </div>
      </div>
    </div>
  </mat-tab-nav-panel>
</div>
